var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardArrowDown = function SvgKeyboardArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 5,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.933 4.8a.9.9 0 0 1-.626-.259L.249 1.484A.84.84 0 0 1 0 .867Q0 .498.25.249A.84.84 0 0 1 .866 0q.367 0 .617.25l2.45 2.449L6.382.248A.84.84 0 0 1 7 0q.368 0 .617.25.25.248.25.617a.84.84 0 0 1-.25.617L4.56 4.541a.899.899 0 0 1-.627.259"
  })));
};
export default SvgKeyboardArrowDown;